import store from '@/store'

export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/modules/skeleton/Home.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiments',
          active: true,
          redirectIfLoggedIn: false,
        },
      ],
    },
  },
  {
    path: '/filter/:id',
    name: 'filter',
    component: () => import('@/views/modules/skeleton/Home.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiments',
          active: true,
        },
      ],
    },
  },
  // Dynamic category routes - add more as needed
  {
    path: '/filter/:id',
    name: 'filter_1',
    component: () => import('@/views/modules/skeleton/Home.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiments',
          active: true,
        },
      ],
    },
  },
  {
    path: '/filter/:id',
    name: 'filter_2',
    component: () => import('@/views/modules/skeleton/Home.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiments',
          active: true,
        },
      ],
    },
  },
  {
    path: '/filter/:id',
    name: 'filter_3',
    component: () => import('@/views/modules/skeleton/Home.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiments',
          active: true,
        },
      ],
    },
  },
  {
    path: '/filter/:id',
    name: 'filter_4',
    component: () => import('@/views/modules/skeleton/Home.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiments',
          active: true,
        },
      ],
    },
  },
  {
    path: '/filter/:id',
    name: 'filter_5',
    component: () => import('@/views/modules/skeleton/Home.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiments',
          active: true,
        },
      ],
    },
  },
  {
    path: '/filter/:id',
    name: 'filter_6',
    component: () => import('@/views/modules/skeleton/Home.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiments',
          active: true,
        },
      ],
    },
  },
  {
    path: '/filter/:id',
    name: 'filter_7',
    component: () => import('@/views/modules/skeleton/Home.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiments',
          active: true,
        },
      ],
    },
  },
  {
    path: '/filter/:id',
    name: 'filter_8',
    component: () => import('@/views/modules/skeleton/Home.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiments',
          active: true,
        },
      ],
    },
  },
  {
    path: '/filter/:id',
    name: 'filter_9',
    component: () => import('@/views/modules/skeleton/Home.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiments',
          active: true,
        },
      ],
    },
  },
  {
    path: '/filter/:id',
    name: 'filter_10',
    component: () => import('@/views/modules/skeleton/Home.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiments',
          active: true,
        },
      ],
    },
  },

  {
    path: '/experiment-details/:id',
    name: 'experiment_details',
    component: () => import('@/views/modules/skeleton/admin/Experiments/ExperimentDetails.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiment Details',
          active: true,
          back: true,
          redirectIfLoggedIn: false,
        },
      ],
    },
  },
  {
    path: '/experiment-details/:id',
    name: 'experiment_details_1',
    component: () => import('@/views/modules/skeleton/admin/Experiments/ExperimentDetails.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiment Details',
          active: true,
          back: true,
        },
      ],
    },
  },
  {
    path: '/experiment-details/:id',
    name: 'experiment_details_2',
    component: () => import('@/views/modules/skeleton/admin/Experiments/ExperimentDetails.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiment Details',
          active: true,
          back: true,
        },
      ],
    },
  },
  {
    path: '/experiment-details/:id',
    name: 'experiment_details_3',
    component: () => import('@/views/modules/skeleton/admin/Experiments/ExperimentDetails.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiment Details',
          active: true,
          back: true,
        },
      ],
    },
  },
  {
    path: '/blank1',
    name: 'blank1',
    component: () => import('@/views/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/blank2',
    name: 'blank2',
    component: () => import('@/views/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/blank3',
    name: 'blank3',
    component: () => import('@/views/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/blank4',
    name: 'blank4',
    component: () => import('@/views/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/blank5',
    name: 'blank5',
    component: () => import('@/views/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/blank6',
    name: 'blank6',
    component: () => import('@/views/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/blank7',
    name: 'blank7',
    component: () => import('@/views/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/blank8',
    name: 'blank8',
    component: () => import('@/views/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },

  {
    path: '/institution-dashboard/:id?',
    name: 'institution_dashboard',
    component: () => import('@/views/modules/skeleton/admin/InstitutionDashboard.vue'),
    meta: {
      title: 'Institution Dashboard',
      icon: 'MonitorIcon',
      navActive: true,
      breadcrumb: [
        {
          text: 'Institution Dashboard',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin-institution-dashboard',
    name: 'admin_institution_dashboard',
    component: () => import('@/views/modules/skeleton/admin/AdminInstitutionDashboard.vue'),
    meta: {
      title: 'Admin Dashboard',
      icon: 'LayoutIcon',
      navActive: true,
      breadcrumb: [
        {
          text: 'Admin Dashboard',
          active: true,
        },
      ],
    },
  },
  {
    path: '/profile/:user_id?',
    name: 'pages_profile',
    component: () => import('@/views/modules/skeleton/Profile.vue'),
    meta: {
      breadcrumb: [
        {
          // text: 'My Experiments',
          active: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
  },
  {
    path: '/admin-profile',
    name: 'admin_profile',
    component: () => import('@/views/modules/skeleton/AdminProfile.vue'),
    meta: {
      breadcrumb: [
        {
          // text: 'My Experiments',
          active: true,
        },
      ],
    },
  },
]
